import React from "react";
import { Input } from "@/shared/components/ui/input";
import { Label } from "@/shared/components/ui/label";
import { Slider } from "@/shared/components/ui/slider";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shared/components/ui/select";

const RoutingLimits = ({ formData, handleChange, t }) => {
  return (
    <div className="space-y-4 mt-4">
      <div className="space-y-4">
        <div className="space-y-2">
          <div className="flex justify-between">
            <Label>{t("priorityHighest")}</Label>
            <span className="text-sm text-slate-500">
              {formData.priority}
            </span>
          </div>
          <Slider
            value={[formData.priority]}
            onValueChange={([v]) => handleChange("priority", v)}
            min={1}
            max={10}
            step={1}
          />
        </div>

        <div className="space-y-2">
          <div className="flex justify-between">
            <Label>{t("weightLoadBalancing")}</Label>
            <span className="text-sm text-slate-500">
              {formData.weight}%
            </span>
          </div>
          <Slider
            value={[formData.weight]}
            onValueChange={([v]) => handleChange("weight", v)}
            min={0}
            max={100}
            step={5}
          />
        </div>

        <div className="space-y-2">
          <div className="flex justify-between">
            <Label>{t("healthScore")}</Label>
            <span className="text-sm text-slate-500">
              {formData.health_score}%
            </span>
          </div>
          <Slider
            value={[formData.health_score]}
            onValueChange={([v]) => handleChange("health_score", v)}
            min={0}
            max={100}
            step={1}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>{t("minAmountThb")}</Label>
          <Input
            type="number"
            value={formData.min_amount}
            onChange={(e) =>
              handleChange("min_amount", parseInt(e.target.value))
            }
          />
        </div>
        <div className="space-y-2">
          <Label>{t("maxAmountThb")}</Label>
          <Input
            type="number"
            value={formData.max_amount}
            onChange={(e) =>
              handleChange("max_amount", parseInt(e.target.value))
            }
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label>{t("dailyLimitThb")}</Label>
        <Input
          type="number"
          value={formData.daily_limit}
          onChange={(e) =>
            handleChange("daily_limit", parseInt(e.target.value))
          }
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label>{t("feePercentage")} (%)</Label>
          <Input
            type="number"
            step="0.1"
            value={formData.fee_percentage}
            onChange={(e) =>
              handleChange("fee_percentage", parseFloat(e.target.value))
            }
          />
        </div>
        <div className="space-y-2">
          <Label>{t("settlementTimeLabel")}</Label>
          <Select
            value={formData.settlement_time}
            onValueChange={(v) => handleChange("settlement_time", v)}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="instant">{t("instant")}</SelectItem>
              <SelectItem value="1hour">{t("oneHour")}</SelectItem>
              <SelectItem value="same_day">{t("sameDay")}</SelectItem>
              <SelectItem value="next_day">{t("nextDay")}</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default RoutingLimits;
